import {useMutation} from '@tanstack/react-query';
import {fetchRest} from '../helpers/fetchRest';
import utils from '../helpers/utils';
import _isEmpty from 'lodash/isEmpty';
import _has from 'lodash/has';

interface FastLinkTokenOptions {
  useCache?: boolean;
}

/**
 * Custom hook to fetch a Yodlee fastlink token from the server
 * @returns {Object} Mutation object with functions and state for fetching fastlink token
 */
export const useFastLinkToken = () => {
  return useMutation({
    mutationKey: ['fastLinkToken'],
    mutationFn: (options?: FastLinkTokenOptions) => {
      let url = utils.getFastLinkTokenPath();

      if (!_isEmpty(options) && _has(options, 'useCache')) {
        url += `?useCache=${options!.useCache}`;
      }

      return fetchRest(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
        },
        credentials: 'include',
      });
    },
  });
};
